import { render, staticRenderFns } from "./novelties_page.vue?vue&type=template&id=7ebb603a&scoped=true"
import script from "./novelties_page.vue?vue&type=script&lang=js"
export * from "./novelties_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb603a",
  null
  
)

export default component.exports